export const ENV = {
  NODE_ENV: import.meta.env.VITE_ENVIRONMENT,
  SERVER_ENPOINT: import.meta.env.VITE_SERVER_ENDPOINT,
};

// Prefixed so that it does not conflict with other cookies
export const AUTH_STORAGE_KEY = '__matchmaker_token';

export const FALLBACK_LANGUAGE = 'en-US';